import type { LC_GetAppMobileProfilesListOut, AppMobileProfile } from './appMobileProfiles.types';


export const mapAppMobileProfiles = (out: LC_GetAppMobileProfilesListOut): AppMobileProfile[] => {
  const items = Array.isArray(out) ? out : out?.profiles;
  if (!items?.length) return [];
  return items.map((item) => ({
    id: item.appProfileId,
    name: item.appProfileName || '',
  }));
};
